import { inject, Injectable } from "@angular/core";
import { catchError, EMPTY, map, Observable } from "rxjs";
import { toFieldStringArray } from "../../../../../common/utils/object-paths";
import { ApiService } from "../../../../api/packbo/api.service";
import { readItemsSuppliers } from "../../../../api/packbo/fn/items/read-items-suppliers";
import { SupplierStore } from "./supplier.store";

@Injectable()
export class SupplierService {
    private readonly store = inject(SupplierStore);
    private readonly apiService = inject(ApiService);

    public loadSupplier(slug: string): Observable<void> {
        const supplierFields = toFieldStringArray({
            id: null,
            name: null,
            banner: null,
            certifications_refs: {
                certifications_id: {
                    id: null,
                    logo: null,
                    name: null,
                    website: null,
                    translations_refs: {
                        languages_code: null,
                        name: null
                    }
                }
            },
            contact_ref: {
                id: null,
                email: null,
                phone_number: null,
                first_name: null,
                last_name: null,
                coord_ref: {
                    id: null,
                    address1: null,
                    address2: null,
                    locality: null,
                    postal_code: null
                }
            },
            coord_ref: {
                id: null,
                address1: null,
                address2: null,
                locality: null,
                postal_code: null,
                geo_point: null
            },
            product_categories_refs: {
                product_categories_id: {
                    id: null,
                    image: null
                }
            },
            email: null,
            is_active: null,
            logo: null,
            package_ref: {
                id: null,
                package_color: null,
                name: null,
                hide_supplier_package: null,
                package_text_color: null,
                translations_refs: {
                    languages_code: null,
                    title: null
                }
            },
            phone_number: null,
            status: null,
            website_url: null,
            translations_refs: {
                languages_code: null,
                summary: null,
                description: null
            },
            is_eco_friendly: null,
            files_refs: {
                directus_files_id: {
                    id: null,
                    type: null
                },
                id: null
            }
        });

        const filters = JSON.stringify({ translations_refs: { slug: { _eq: slug } } });

        return this.apiService.invoke(readItemsSuppliers, { fields: supplierFields, filter: filters }).pipe(
            map((supplier) => this.store.setSupplier(supplier.data?.[0] ?? null)),
            catchError(() => EMPTY)
        );
    }
}
